import React, { useState } from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import { login } from '../actions/user'
import Modal from '../components/Modal'

import titleSrc from '../assets/title.png'
import backgroundSrc from '../assets/background.jpg'


const styles = {
  root: {
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    background: `url(${backgroundSrc})`,
  },
  content: {
    width: 600,
    maxWidth: '100%',
  },
  title: {
    top: 30,
    position: 'fixed',
  },
  textField: {
    marginTop: 10,
    '& fieldset': {
      borderColor: 'white !important',
    },
    '& input': {
      color: 'white !important',
    },
  },
  modal: {
    alignItems: 'flex-end',
  },
}


const Login = ({
  classes,
  isLoading,
  login: loginAction,
}) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const createChangeHandler = fn => e => fn(e.target.value)
  const handleLogin = () => loginAction(email, password)

  return (
    <div className={classes.root}>
      <Modal
        open
        title="Login"
        isLoading={isLoading}
        submitLabel="connection"
        onSubmit={handleLogin}
        containerClassName={classes.modal}
      >
        <div className={classes.content}>
          <img alt="Elytiz" src={titleSrc} className={classes.title} />

          <Typography>E-mail</Typography>

          <TextField
            fullWidth
            type="email"
            name="email"
            value={email}
            variant="outlined"
            className={classes.textField}
            onChange={createChangeHandler(setEmail)}
          />

          <Typography className="mt3">Password</Typography>
          <TextField
            fullWidth
            type="password"
            name="password"
            value={password}
            variant="outlined"
            className={classes.textField}
            onChange={createChangeHandler(setPassword)}
          />
        </div>
      </Modal>
    </div>
  )
}


Login.propTypes = {
  login: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
})


export default connect(mapStateToProps, {
  login,
})(withStyles(styles)(Login))
